<template lang="pug">
  li
    f7-link(
      :href="`/students/${student.id}/sent_curriculums`"
      class="item-content")
      .item-media
        avatar-image(
          :src="student.avatarImageUrl"
          purpose="list")
      .item-inner
        .item-title {{ student.fullName }}
</template>

<style lang="scss" scoped>
li {
  height: 66px;
}

.item-media {
  padding-top: 7.5px !important;
  padding-bottom: 7.5px !important;
  width: 60px;
}

.item-title {
  line-height: 38px !important;
}
</style>

<script>
import AvatarImage from '@/components/atoms/AvatarImage'

export default {
  components: { AvatarImage },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
}
</script>
